.f1{border-radius:0.5rem;}